<template>
  <div>
    <!-- 上下50条 -->
    <el-dialog :title="$t('message.upAndDown')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1200px" center>
      <div class="content">
        <div class="table" v-if="type == 'CW'">
          <ol>
            <!-- 发送对象 -->
            <li>{{ $t('message.sendTo') }}</li>
            <!-- 发送时间 -->
            <li>{{ $t('message.sendingTime') }}</li>
            <!-- 聊天内容 -->
            <li class="flex5">{{ $t('message.chatContent') }}</li>
          </ol>
          <ul v-for="(item, index) in upAndDownList" :key="index">
            <!-- 发送对象 -->
            <li>{{ item.send_realname }}</li>
            <!-- 发送时间 -->
            <li>{{ item.send_time }}</li>
            <!-- 聊天内容 -->
            <li class="flex5">
              <div v-html="item.body"></div>
            </li>
          </ul>
        </div>
        <div class="table" v-else>
          <div class="table">
            <ol>
              <!-- 发送对象 -->
              <li>{{ $t('message.sendTo') }}</li>
              <!-- 发送时间 -->
              <li>{{ $t('message.sendingTime') }}</li>
              <!-- 聊天内容 -->
              <li class="flex5">{{ $t('message.chatContent') }}</li>
            </ol>
            <ul v-for="(item, index) in upAndDownList" :key="index">
              <!-- 发送对象 -->
              <li>{{ item.send_realname }}</li>
              <!-- 发送时间 -->
              <li>{{ item.MsgTime }}</li>
              <!-- 聊天内容 -->
              <li class="flex5">
                <!-- <div v-html="item.Text"></div> -->
                <div v-show="false">{{ item.Text }}</div>
                <recordTextEle :_elements="item.MsgBodyText[0]" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import recordTextEle from '@/components/common/messageElements/recordTextEle.vue'
export default {
  components: {
    recordTextEle,
  },
  data() {
    return {
      dialogVisible: false,
      upAndDownList: [],
      type: '',
      text: '',
    };
  },
  watch: {
    // 监听text变化，当text更新时检查并定位
    text(newVal) {
      if (newVal && this.dialogVisible) {
        setTimeout(() => {
          this.locateMatchingContent();
        }, 1000);
      }
    },
    // 监听对话框显示状态，当对话框打开时检查
    dialogVisible(visible) {
      if (visible && this.text) {
        setTimeout(() => {
          this.locateMatchingContent();
        }, 1000);
      }
    }
  },
  methods: {
    // 定位到与text内容匹配的flex5元素
    locateMatchingContent() {
      const flex5Elements = document.querySelectorAll('.table li.flex5 div');
      let found = false;
      flex5Elements.forEach(element => {
        const content = element.textContent || '';
        // 检查内容是否匹配（不区分大小写）
        if (content.toLowerCase().includes(this.text.toLowerCase())) {
          // 滚动到匹配元素位置
          const ulElement = element.closest('ul');
          if (ulElement) {
            ulElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            // 高亮显示匹配元素（可选）
            ulElement.style.backgroundColor = '#ffe6e6';
            // setTimeout(() => {
            //   element.style.backgroundColor = '';
            // }, 2000);
          }
          found = true;
        }
      });

      if (!found && this.text) {
        console.log('未找到匹配的内容');
      }
    },
    // 设置text并打开对话框
    openDialog(list, type, searchText = '') {
      this.upAndDownList = list;
      this.type = type;
      this.text = searchText;
      this.dialogVisible = true;
    }
  }
}
</script>
<style lang='scss' scoped>
.table {
  max-height: 600px;
  overflow-y: auto;
  position: relative;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 99;
  }
}

.flex5 {
  flex: 5;
  justify-content: flex-start;
}
</style>